module.exports = __webpack_public_path__ + "static/media/MHRP75N0001.c81c5174.svg";